export const iconFontAwesomeDevicesHardwareLaptop = (
	<i className="fa-solid fa-laptop"></i>
);
